/**
 * Deep-link return path consumed after sign-in.
 *
 * M07 S06: `/sponsor/:slug` stashes the intended destination before
 * redirecting to sign-in. M09 S02: VerifyEmail stashes `/profile?welcome=1`
 * after email verification so new candidates land on the Get Started quest.
 * Only same-origin relative paths are honoured (open-redirect guard).
 */

const RETURN_TO_KEY = 'bp_return_to';

export function stashReturnPath(path: string): void {
  try {
    sessionStorage.setItem(RETURN_TO_KEY, path);
  } catch {
    /* storage unavailable — sign-in falls back to /home */
  }
}

export function consumeReturnPath(): string {
  try {
    const returnTo = sessionStorage.getItem(RETURN_TO_KEY);
    sessionStorage.removeItem(RETURN_TO_KEY);
    if (returnTo && returnTo.startsWith('/') && !returnTo.startsWith('//')) {
      return returnTo;
    }
  } catch {
    /* storage unavailable */
  }
  return '/home';
}
